const getCurrentProject = (state) => state.project.currentProject;

const projectSelectors = {
  getCurrentProject,
};

export default projectSelectors;
